module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C317"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "P20"
  }, [_c('a', {
    attrs: {
      "href": "#/html/05_Acknowle#page_ix"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_Introduc#page_1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_CHAPTER#page_22"
    }
  }, [_vm._v("CHAPTER ")])]), _c('a', {
    attrs: {
      "href": "#/html/07_CHAPTER#page_22"
    }
  }, [_vm._v("1")]), _c('a', {
    attrs: {
      "href": "#/html/07_CHAPTER#page_22"
    }
  }, [_vm._v(". The Game")])]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_CHAPTER#page_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ")])]), _c('span', {
    attrs: {
      "href": "#/html/08_CHAPTER#page_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _c('span', {
    attrs: {
      "href": "#/html/08_CHAPTER#page_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(". Charlotte’s Web")])]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_CHAPTER#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ")])]), _c('span', {
    attrs: {
      "href": "#/html/09_CHAPTER#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _c('span', {
    attrs: {
      "href": "#/html/09_CHAPTER#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(". Broken Families")])]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_CHAPTER#page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ")])]), _c('span', {
    attrs: {
      "href": "#/html/10_CHAPTER#page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "href": "#/html/10_CHAPTER#page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(". Cutting the Head off the Snake")])]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#page_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ")])]), _c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#page_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#page_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(". The Prosecutor’s Darling")])]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_Conclusi#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Fruit of the Poison Tree")])]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_Notes#page_143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_Bibliogr#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_Index#page_161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57a866b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_Contents.vue
// module id = 66
// module chunks = 0